import React, { useEffect } from "react";
import styles from "../SearchSection/style.module.css";
import { useTranslation } from "react-i18next";
import Logo from "../../images/ezseat_logo.webp"; // ✅ เพิ่มโลโก้
import Background from "../../images/destination/phiphi.webp"; // ✅ เพิ่มภาพพื้นหลัง

const SearchSectionCC = (props) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === 'th' ? 'th_TH' : 'en_US';

  useEffect(() => {
    // Reinitialize busx search form
    const script = document.createElement('script');
    script.src = "https://cdn.busx.com/gds/resources/assets/js/busx-search-form-react.min.js";
    script.type = "module";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []); // Empty dependency array means this runs once when component mounts

  return (
    <div 
      className={styles.searchSection} 
      style={{
        backgroundImage: `url(${Background})`, // ✅ ใช้ภาพพื้นหลัง
        width: "100%",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        padding: "50px 0",
        color: "#fff",
      }}
    >      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <div className="row">
          {/* Logo shown on all screen sizes */}
          <div className="text-center mb-3">
            <img
              src={Logo}
              alt="Logo"
              style={{
                maxWidth: "150px",
                width: "auto",
                display: "block",
                margin: "0 auto",
              }}
            />
          </div>
          <div className="col-lg-12">
            <div className={`${styles.searchWrapper} mt-lg-3`}> {/* ✅ เพิ่มระยะห่างด้านบนเฉพาะจอใหญ่ */}
              <h2 
                className={styles.searchHeader} 
                style={{ color: "#fff", marginTop: "65px", fontFamily: "Reey" }} // ✅ เปลี่ยนสีตัวหนังสือเป็นขาว + เพิ่ม marginTop
              >
                {t('search.header')}
              </h2>
              <div
                id="busx-search-form"
                data-url="https://booking.ezseat.asia"
                data-appkey="26b0df8f436dd61564d1ade0f1b24250"
                data-locale={locale}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchSectionCC;
